<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- <b-button
        v-if="user && user.ngo "
        @click="processModal = true"
        variant="flat-dark"
        class="btn-icon rounded-circle"
        v-b-tooltip.hover.v-secondary.bottom
        title="المعاملات"
        ><feather-icon size="19" icon="FilePlusIcon"></feather-icon
      ></b-button> -->
      <router-link
        v-if="user.ngo"
        :to="{ name: 'ngo-profile' }"
        class="mx-50 d-flex align-items-center"
        style="gap: 8px; cursor: pointer"
      >
        <b-avatar
          size="50"
          class="bg-white"
          :src="mainNgoData ? mainNgoData.logo : ''"
        />
        <div class="text-dark">
          {{ mainNgoData ? mainNgoData.name_ar : "" }}
        </div>
      </router-link>
    </div>
    <processes-modal v-model="processModal" />
    <feedback-modal />

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler class="d-none d-lg-block" />
      <b-button
        :to="user.ngo ? '/docs' : '/ministry/docs?ministry=true'"
        variant="flat-secondary"
        class="btn-icon rounded-circle text-body"
      >
        <feather-icon icon="HelpCircleIcon" size="21"
      /></b-button>
      <b-button
        v-can="{ slug: 'ngo_messages', action: 'S' }"
        to="/messaging/received"
        variant="flat-secondary"
        class="btn-icon rounded-circle text-body"
      >
        <feather-icon icon="MailIcon" size="21"
      /></b-button>
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BAvatar, BNavbarNav, BButton, VBTooltip } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import Locale from "./components/Locale.vue";
import DarkToggler from "./components/DarkToggler.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import ProcessesModal from "./components/processes-modal/index.vue";
import FeedbackModal from "@/components/feedback-modal/index.vue";
import AuthHelpers from "@/utils/auth-helpers";
import { mapGetters, mapActions } from "vuex";
import organizationList from "@/navigation/horizontal/organization";

export default {
  components: {
    BLink,
    BAvatar,
    BNavbarNav,
    BButton,
    Bookmarks,
    Locale,
    DarkToggler,
    NotificationDropdown,
    UserDropdown,
    ProcessesModal,
    FeedbackModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  created() {
    if (this.user.ngo) {
      // this.fetchNgoData();
      this.fetchMainNgoData();
    }
  },
  methods: {
    ...mapActions("NgoProfile", ["fetchNgoData" , "fetchMainNgoData"]),
  },
  computed: {
    ...mapGetters("User", ["user"]),
    ...mapGetters("NgoProfile", ["ngoData", "loading" , "mainNgoData"]),

    isUserTemp() {
      return AuthHelpers.isUserTemp();
    },
    isUserMinistry() {
      return AuthHelpers.isUserMinistry();
    },
  },
  data() {
    return {
      processModal: false,
    };
  },
};
</script>
